import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../ui/components/button/Button";
import { Checkbox } from "../../../../ui/components/form/checkbox/Checkbox";
import { Modal } from "../../../../ui/components/modal/Modal";
import { Typography } from "../../../../ui/components/typography/Typography";
const FEEDBACK_OPTIONS = [
    "incorrect_requirement",
    "requirement_already_installed",
    "explanation_was_unclear",
    "other",
];
export const FeedbackModal = ({ isOpen, onClose, onSuccess, }) => {
    const { t } = useTranslation(["health_check"]);
    const [checkedOptions, setCheckedOptions] = useState([]);
    return (React.createElement(Modal, { isOpen: isOpen, size: "sm", title: t("detail::feedback_modal::title"), onClose: onClose },
        React.createElement(Typography, { appearance: "subdued", typographyType: "body-sm" }, t("detail::feedback_modal::description")),
        React.createElement("div", { className: "mt-4 space-y-2" }, FEEDBACK_OPTIONS.map((key) => (React.createElement(Checkbox, { checked: checkedOptions.includes(key), key: key, onChange: (e) => {
                const isChecked = e.target.checked;
                setCheckedOptions((prev) => isChecked ? [...prev, key] : prev.filter((o) => o !== key));
            } }, t(`detail::feedback_modal::options::${key}`))))),
        React.createElement("div", { className: "mt-4 grid grid-cols-2 gap-x-2" },
            React.createElement(Button, { buttonType: "tertiary", className: "w-full", filled: "weak", size: "sm", onClick: onClose }, t("detail::feedback_modal::buttons::cancel")),
            React.createElement(Button, { buttonType: "primary", className: "w-full", size: "sm", onClick: () => {
                    onSuccess(checkedOptions);
                } }, t("detail::feedback_modal::buttons::confirm")))));
};
